function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 2",
  cx: 41,
  cy: 40,
  rx: 41,
  ry: 40,
  fill: "#00a68d"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-lightbulb",
  d: "M33.81 56.048a2.53 2.53 0 00.449 1.431l1.43 2.079a2.7 2.7 0 002.229 1.155h5.164a2.7 2.7 0 002.229-1.155l1.43-2.079a2.528 2.528 0 00.449-1.431v-3.1H33.806zm-8.039-22.521a13.9 13.9 0 003.645 9.368 23.077 23.077 0 014.369 7.4c0 .021.006.042.009.063h13.41c0-.021.006-.041.009-.063a23.077 23.077 0 014.369-7.4 13.9 13.9 0 003.645-9.368 14.492 14.492 0 00-14.773-14.241 14.425 14.425 0 00-14.683 14.241zM40.5 27.054a6.594 6.594 0 00-6.695 6.473 1.34 1.34 0 01-2.678 0 9.231 9.231 0 019.373-9.062 1.3 1.3 0 110 2.589z",
  fill: "#a1dbd3"
}));
var SvgLightIcon = function SvgLightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 80"
  }, props), _ref);
};
export default SvgLightIcon;